// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editableInputContainer_Gungz {
  display: flex;
  width: 100%;
  align-items: center;
  font-family: "Inter", sans-serif;
  gap: 5px;
}

.editableInputHeader_dgFgb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 30px;

  .info_zP73v {
    font-size: 11px;
    -webkit-user-select: none;
            user-select: none;
    color: var(--_71717a-color);
  }

  div {
    text-decoration: underline;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    font-size: 14px;
    font-weight: 600;
    color: var(--_2-color);
    opacity: 0;
  }
  p,span {
    margin: 5px 0;
    color: #000 !important;
    margin: 0;
    font-weight: 500;
    font-size: 18px;
  }
}
.editableInputContainer_Gungz:hover {
  .editableInput_Zpl2O,.editableInputHeader_dgFgb {
    .button_NyYXB {
      opacity: 1;
    }
  }
}
.limit_Twmpn{
  margin-left: auto !important;
  width: fit-content;
  font-size: 11px;
  color: var(--_75-color);
}
.editableInput_Zpl2O {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  gap: 8.5px;
.button_NyYXB {
  text-decoration: underline;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--_2-color);
  opacity: 0;
  text-align: end;
}
  span {
    font-size: 14px;
    font-weight: 400;
    color: #717171;
  }
  input,
  .textarea_TAKOR {
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    color: var(--_75-color);
    min-height: 21px !important;
    background-color: var(--f4-background);
    border-radius: 5px;
    font-family: "Inter", sans-serif;
    box-sizing: border-box;
    width: 100%;
    field-sizing: content;
    min-height: 21px !important;
    padding: 8px 4px;
  }
  .textarea_TAKOR{
    padding: 8px;
  }

  .textarea_TAKOR {
    resize: none;
    width: 100%;
    min-height: 60px !important;
  }
  input:disabled,
  select:disabled,
  option:disabled,
  input[readonly],
  select[readonly],
  option[readonly],
  input::placeholder,
  select::placeholder {
    color: var(--_75-color); 
  }
  input::placeholder,
  select::placeholder,
  option::placeholder,
  input::placeholder,
  select::placeholder,
  option::placeholder,
  input::placeholder,
  select::placeholder {
    color: var(--_75-color); 
  }

  input,
  select,
  option {
    color: var(--_75-color); 
  }
  input[readonly],
  textarea[readonly] {
    background-color: transparent;
  }
}

.verify_u9JBh {
  right: 10px;
  top: 31px;
  font-weight: 600 !important;
  font-size: 14px;
  color: #000 !important;
  cursor: pointer;
  text-align: end;
}

.verify_u9JBh:hover {
  text-decoration: underline;
}

.error_UAvFH {
  font-size: 10px;
  font-weight: 400;
  color: #b40e1b;
}

@media (width <= 658px) {
  .editableInputHeader_dgFgb {
    div {
      opacity: 1;
    }
  }
}

.typeClient_qcUi2 {
  display: flex;
  background-color: #f3f3f3;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 6px;
  gap: 10px;
  width: 300px;
  input {
    flex: 2 1;
  }
  button {
    border: none;
    outline: none;
    padding: 12px;
    box-sizing: border-box;
    flex: 1 1;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
  }
  button[disabled],
  input[disabled],
  select[disabled],
  option[disabled],
  textarea[disabled] {
    background-color: transparent;
  }
}

.typeClientActivate_URh6s {
  button {
    background-color: transparent;
    cursor: pointer;
    color: #999999;
  }
  .selected_a044q {
    background-color: var(--white-color);
    box-shadow: 0px 3px 8px rgb(172, 172, 172);
    color: black;
  }
}

.typeClientDisabled_zRcYV {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AccountSettings/EditableInput/EditableInput.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;;EAEZ;IACE,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;IACE;MACE,UAAU;IACZ;EACF;AACF;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,UAAU;AACZ;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,eAAe;AACjB;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;;IAEE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;IAC3B,sCAAsC;IACtC,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,2BAA2B;EAC7B;EACA;;;;;;;;IAQE,uBAAuB;EACzB;EACA;;;;;;;;IAQE,uBAAuB;EACzB;;EAEA;;;IAGE,uBAAuB;EACzB;EACA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ;IACE,SAAO;EACT;EACA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;;;;;IAKE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,eAAe;IACf,cAAc;EAChB;EACA;IACE,oCAAoC;IACpC,0CAA0C;IAC1C,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.editableInputContainer {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  font-family: \"Inter\", sans-serif;\n  gap: 5px;\n}\n\n.editableInputHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 30px;\n\n  .info {\n    font-size: 11px;\n    user-select: none;\n    color: var(--_71717a-color);\n  }\n\n  div {\n    text-decoration: underline;\n    cursor: pointer;\n    user-select: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--_2-color);\n    opacity: 0;\n  }\n  p,span {\n    margin: 5px 0;\n    color: #000 !important;\n    margin: 0;\n    font-weight: 500;\n    font-size: 18px;\n  }\n}\n.editableInputContainer:hover {\n  .editableInput,.editableInputHeader {\n    .button {\n      opacity: 1;\n    }\n  }\n}\n.limit{\n  margin-left: auto !important;\n  width: fit-content;\n  font-size: 11px;\n  color: var(--_75-color);\n}\n.editableInput {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  width: 100%;\n  gap: 8.5px;\n.button {\n  text-decoration: underline;\n  cursor: pointer;\n  user-select: none;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--_2-color);\n  opacity: 0;\n  text-align: end;\n}\n  span {\n    font-size: 14px;\n    font-weight: 400;\n    color: #717171;\n  }\n  input,\n  .textarea {\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--_75-color);\n    min-height: 21px !important;\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    font-family: \"Inter\", sans-serif;\n    box-sizing: border-box;\n    width: 100%;\n    field-sizing: content;\n    min-height: 21px !important;\n    padding: 8px 4px;\n  }\n  .textarea{\n    padding: 8px;\n  }\n\n  .textarea {\n    resize: none;\n    width: 100%;\n    min-height: 60px !important;\n  }\n  input:disabled,\n  select:disabled,\n  option:disabled,\n  input[readonly],\n  select[readonly],\n  option[readonly],\n  input::placeholder,\n  select::placeholder {\n    color: var(--_75-color); \n  }\n  input::placeholder,\n  select::placeholder,\n  option::placeholder,\n  input::placeholder,\n  select::placeholder,\n  option::placeholder,\n  input::placeholder,\n  select::placeholder {\n    color: var(--_75-color); \n  }\n\n  input,\n  select,\n  option {\n    color: var(--_75-color); \n  }\n  input[readonly],\n  textarea[readonly] {\n    background-color: transparent;\n  }\n}\n\n.verify {\n  right: 10px;\n  top: 31px;\n  font-weight: 600 !important;\n  font-size: 14px;\n  color: #000 !important;\n  cursor: pointer;\n  text-align: end;\n}\n\n.verify:hover {\n  text-decoration: underline;\n}\n\n.error {\n  font-size: 10px;\n  font-weight: 400;\n  color: #b40e1b;\n}\n\n@media (width <= 658px) {\n  .editableInputHeader {\n    div {\n      opacity: 1;\n    }\n  }\n}\n\n.typeClient {\n  display: flex;\n  background-color: #f3f3f3;\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 6px;\n  gap: 10px;\n  width: 300px;\n  input {\n    flex: 2;\n  }\n  button {\n    border: none;\n    outline: none;\n    padding: 12px;\n    box-sizing: border-box;\n    flex: 1;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n  }\n  button[disabled],\n  input[disabled],\n  select[disabled],\n  option[disabled],\n  textarea[disabled] {\n    background-color: transparent;\n  }\n}\n\n.typeClientActivate {\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: #999999;\n  }\n  .selected {\n    background-color: var(--white-color);\n    box-shadow: 0px 3px 8px rgb(172, 172, 172);\n    color: black;\n  }\n}\n\n.typeClientDisabled {\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editableInputContainer": `editableInputContainer_Gungz`,
	"editableInputHeader": `editableInputHeader_dgFgb`,
	"info": `info_zP73v`,
	"editableInput": `editableInput_Zpl2O`,
	"button": `button_NyYXB`,
	"limit": `limit_Twmpn`,
	"textarea": `textarea_TAKOR`,
	"verify": `verify_u9JBh`,
	"error": `error_UAvFH`,
	"typeClient": `typeClient_qcUi2`,
	"typeClientActivate": `typeClientActivate_URh6s`,
	"selected": `selected_a044q`,
	"typeClientDisabled": `typeClientDisabled_zRcYV`
};
export default ___CSS_LOADER_EXPORT___;
